module.exports = __webpack_public_path__ + "static/img/3.c929f7fc.png";